<template>
	<div class="loader">
	<div class="spinner-border text-primary" role="status">
		<span class="sr-only">Loading...</span>
	</div>
	</div>
</template>

<script>
export default {
	name: 'page-loader'
}
</script>

<style scoped>

</style>
